import { render } from "./AnswerComponent.vue?vue&type=template&id=5f65b908&scoped=true"
import script from "./AnswerComponent.vue?vue&type=script&lang=js"
export * from "./AnswerComponent.vue?vue&type=script&lang=js"

import "./AnswerComponent.vue?vue&type=style&index=0&id=5f65b908&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f65b908"]])

export default __exports__